<template>
  <section class="flex w-full h-full">
    <div class="p-4 pt-0 flex-1 box-border overflow-hidden">
      <div class="h-8 text-theme text-medium text-center mb-4 -ml-4" style="background: #EFF4FD;line-height: 32px;width: calc(100% + 32px);">
        数据分析仅统计“审核通过”的数据
      </div>
      <div class="w-full h-full flex flex-col bg-white overflow-auto" v-if="flag">
        <header
          class="mt-6 pl-5 pr-4 leading-20 box-border border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold"
        >
          推送报告设置
        </header>
        <div class="py-5 px-6 flex-1 box-border overflow-auto">
          <div class="text-medium text-theme-black-650 leading-22 flex items-center">
            <span class="mr-6">通过 “ 调研工厂+ ” 推送报告结果</span>
            <el-switch v-model="flag" @change="onChangeFlag" />
          </div>
          <div v-if="flag" class="bg-card-bg-gray py-3 px-4 mt-2">
            <div>
              <div class="text-medium text-theme-black-650 leading-22">
                <span>将报告推送给</span>
                <el-select
                  class="bg-white-input mx-2"
                  v-model="pushAnsByQid"
                  @change="onChangeValue"
                  placeholder="请选择题目"
                  style="width: 312px"
                >
                  <el-option v-for="q in textFillList" :value="q.id" :key="q.id" :label="q.content.text" />
                </el-select>
                <span>填写的手机号。</span>
              </div>
            </div>
            <div ref="container">
              <div class="mt-2 mb-1 leading-22 text-medium text-yellow-theme">
                <span> 请填写的手机号的用户，扫码关注公众号，获取报告。</span>
                <br />
                <span>已关注公众号的用户，回复关键词“1”获取报告。</span>
              </div>
              <div>
                <img :src="qrSrc" width="106" height="106" alt="" class="align-bottom" />
                <el-button :disabled="disabled" class="ml-3" type="text" @click="onDownloadQrcode">下载二维码</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PushReportInit @clickPush="flag = true" v-else/>
    </div>
    <aside class="w-290px">
      <PushReportAside :showImg="flag"/>
    </aside>
  </section>
</template>

<script>
import { surveyInfo } from '@/api/wenjuan/wjquestion'
import { saveSurveySetting } from '@/api/wenjuan/publish'
import { questionType } from '@dygc/question'
import html2canvas from 'html2canvas'
import { dataURLToBlob } from '@dygc/shared'
import GlobalConfig from '@/global/config'
import PushReportInit from './components/PushReportInit'
import PushReportAside from './components/PushReportAside'

export default {
  name: 'PushReport',
  components: { PushReportInit, PushReportAside },
  props: {},
  data() {
    return {
      flag: false,
      pushAnsByQid: '',
      disabled: false,
      qrSrc: process.env.VUE_APP_OFFICIAL_ACCOUNT_QR_CODE_GET_REPORT
    }
  },
  watch: {},
  computed: {
    textFillList() {
      const fillTypes = [
        questionType.CELLPHONE,
        questionType.PHONE_VALIDATE,
        questionType.MULTIPLE_TEXT_FILL,
        questionType.SINGLE_TEXT_FILL
      ]
      const questionList = this.$store.getters.questionList
      const groupList = this.$store.getters.groupQuestionList
      return []
        .concat(questionList)
        .concat(groupList)
        .filter(i => fillTypes.includes(i.question_type))
    }
  },
  methods: {
    onDownloadQrcode() {
      if (!this.pushAnsByQid) {
        this.$message.warning('题目不能为空')
        return
      }
      this.disabled = true
      let loading = this.$loading({
        text: '正在生成。。。',
        background: 'rgba(0,0,0,0.65)'
      })
      const content = this.$refs.container
      const container = document.createElement('div')
      const span = document.createElement('span')
      container.style.width = '400px'
      container.style.textAlign = 'center'
      span.innerText = '您的报告已生成，请用微信扫码查看。'
      container.append(span)
      container.append(content.cloneNode(true))
      document.body.appendChild(container)

      let buttons = container.getElementsByClassName('el-button')
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].remove()
      }

      html2canvas(container)
        .then(canvas => {
          const blob = dataURLToBlob(canvas.toDataURL('image/png'))
          saveAs(blob, `报告.png`)
        })
        .finally(() => {
          this.disabled = false
          document.body.removeChild(container)
          loading.close()
        })
    },
    onChangeValue() {
      saveSurveySetting({
        id: GlobalConfig.getSurveyId(),
        otherSetting: { pushAnsByQid: this.pushAnsByQid }
      }).then(res => {
        this.$message.success('修改成功')
      })
    },
    init() {
      surveyInfo(GlobalConfig.getSurveyId()).then(res => {
        let otherSetting = res.data.data.otherSetting || {}
        if (otherSetting.pushAnsByQid) {
          this.pushAnsByQid = otherSetting.pushAnsByQid
          this.flag = true
        }
      })
    },
    onChangeFlag() {
      if (!this.flag && this.pushAnsByQid) {
        this.pushAnsByQid = ''
        this.onChangeValue()
      }
    }
  },
  created() {
    this.init()
  },
  mounted() {}
}
</script>
